import { JSX, lazy, ReactNode } from 'react';
import { Navigate, Route, Routes } from "react-router-dom"

const PageNotFound = lazy(() => import("@/core/components/errors/error404"));

interface Props {
	children: ReactNode
}
const RoutesWithNotFound = ({ children }: Props): JSX.Element => {
	return (
		<Routes>
			{children}
			<Route path="*" element={<Navigate to="/404" />} />
			<Route path="/404" element={<PageNotFound />} />
		</Routes>
	)
}
export default RoutesWithNotFound;